export default class BundleCancelled {
	readonly cancelledBookings: number;
	readonly cancelledPax: number;

	constructor(json: any) {
		this.cancelledBookings = json.cancelledBookings;
		this.cancelledPax = json.cancelledPax;
	}
}
